
export const noop = fn => fn;
export const isArray = Array.isArray;
export const isBoolean = (value) => typeof value === 'boolean';
export const isFunction = (value) => typeof value === 'function';
export const isNumber = (value) => typeof value === 'number';
export const isObject = (value) => typeof value === 'object';
export const isString = (value) => typeof value === 'string';
export const isUndefined = (value) => typeof value === 'undefined';

export const isEmpty = (value) => {

  if (isUndefined(value) || value === null || value === false || value === 0) {
    return true;
  }

  if (isArray(value) || isString(value)) {
    return value.length === 0;
  }

  if (isObject(value)) {
    return value.constructor === Object && Object.keys(value).length === 0;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/utils.js